const userHi = {
    login: require('../../lang/hi/user/SignIn').default,
    registration: require('../../lang/hi/user/Registration').default,
    changePass: require('../../lang/hi/user/ChangePassword').default,
    profile: require('../../lang/hi/user/Profile').default,
    forgotPassword: require('../../lang/hi/user/ForgotPassword').default,
};

export default userHi;